import { render, staticRenderFns } from "./TheSort.vue?vue&type=template&id=7c56943b"
import script from "./TheSort.vue?vue&type=script&lang=ts"
export * from "./TheSort.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreSortTheModalHeader: require('/usr/src/nuxt-app/components/core/sort/TheModalHeader.vue').default,CoreSortTheModal: require('/usr/src/nuxt-app/components/core/sort/TheModal.vue').default})
